<template>
  <div v-if="job">
    <div class="flex mb-12">
      <div class="single-company-image md:mr-8">
        <a :href="`companies/${job.company.slug}`" :target="`_blank`" :title="`${job.company.name} Logo`">
          <img
          class="object-contain card-img-bottom img-fluid frame-company-logo lazyload"
          :data-src="job.company.logo"
          :alt="`${job.company.logo} Logo`"/>
        </a>
      </div>
      <div class="w-full header-job-content lg:w-3/4">
        <h2 class="title-position capitalize font-bold text-24 lg:text-32 lg:leading-48 break-all">{{ job.title }}</h2>
        <p class="company-name mt-11px md:mt-2 lg:mt-4px lg:mt-0 lg:leading-21">{{ job.company.name }}</p>
        <div class="mt-6 header-apply-wrapper inline-block">
          <a @click="recordClick(job.id, job.slug, job.is_linkout ? 1 : 0, job.linkout_url, job.location.name.toLowerCase().replace(/ /g, '-').replace(/[^\w-]+/g, ''))">
            <primary-button
              class="only-desktop"
              title="Apply Now"
              v-view="toggleApplyNowCallout"
              >Apply Now</primary-button>
            <primary-button
              class="only-mobile"
              style="width: unset;"
              title="Apply Now"
              size="large"
              v-view="toggleApplyNowCallout"
              >Apply Now</primary-button>
          </a>
        </div>
      </div>
    </div>

    <vs-tabs
      @input="inputTab"
      v-model="selectedTabIndex"
      ref="tabsContent"
      class="lg:mb-16 jobs-vs-tabs"
    >
      <vs-tab label="Job Details" title="Job Details">
        <div class="tab-text tab-job-details text-editor-content">
          <div class="flex job-detail-header-info">
            <div class="job-detail-box" v-if="job.salary_quoted !== ''">
              <p class="font-bold info-title">SALARY</p>
              <p class="info-content mb-0">{{ job.salary_quoted }}</p>
            </div>
            <div class="job-detail-box">
              <p class="font-bold info-title">LOCATION</p>
              <p class="info-content mb-0">{{ job.location.name }}</p>
            </div>
            <div class="job-detail-box only-mobile">
              <p class="font-bold info-title">JOB TYPE</p>
              <p class="info-content mb-0">
                <span class="inline-block mb-6px" v-for="(job_type, index) in job.job_types" :key="index">
                  {{ job_type.name }}<span v-if="index+1 < job.job_types.length">,&nbsp;</span>
                </span>
              </p>
            </div>
          </div>
          <div class="flex bagdes-wrapper">
            <div class="categories-wrapper flex flex-wrap">
                <div v-for="(category, index) in job.categories" :key="index" class="category-chip-wrapper">
                  <primary-button
                    size="small"
                    :color="category.background_color"
                    :text-color="category.color"
                    class="lg:hidden" disabled
                    :title="category.name">
                      {{ category.name }}
                  </primary-button>
                  <primary-button
                    size="small"
                    :color="category.background_color"
                    :text-color="category.color"
                    :href="addCCToRoute(`/jobs?${QueryParameters.CATEGORIES}[]=${category.id}`)"
                    class="hidden lg:block"
                    :title="category.name">
                      {{ category.name }}
                  </primary-button>
                </div>
            </div>
            <div class="bagde-divider only-desktop"></div>
            <div v-for="(job_type, index) in job.job_types" :key="index" class="custom-chip-class only-desktop mr-4">
              <a :title="job_type.name || ''" :href="addCCToRoute(`/jobs?${QueryParameters.JOB_TYPE}=${job_type.id}`)">
                <vs-chip transparent :color="job_type.color ? job_type.color : slugify(job_type.name)">
                  {{ job_type.name || '' }}
                </vs-chip>
              </a>
            </div>
          </div>
          <div class="job-detail-content" v-html="job['content']"></div>
          <div
            ref="contentApplyNowBottom"
            class="lg:hidden apply-now-mobile-bottom"
            :class="{ 'apply-now-visible': !showApplyCallout }"
          >
            <a
              @click="recordClick(job.id, job.slug, job.is_linkout ? 1 : 0, job.linkout_url, job.location.name.toLowerCase().replace(/ /g, '-').replace(/[^\w-]+/g, ''))"
            >
              <primary-button size="large" class="w-full mt-6">Apply Now</primary-button>
            </a>
          </div>
        </div>
      </vs-tab>
      <vs-tab label="Location" title="Location">
        <div class="tab-text tab-job-location">
          <div class="mt-24px lg:mt-40px">
            <rounded-corners>
              <google-map-basic
                :markers="{ lat: job.location.latitude, lng: job.location.longitude }"
              ></google-map-basic>
            </rounded-corners>
          </div>


          <div class="hiring-cities-wrapper" v-if="job.hiring_cities.length > 0">
            <h2 class="hiring-cities">Hiring cities</h2>
            <div class="listing-cities">
              <p v-for="(hiring_city, index) in job.hiring_cities" :key="index">
                <a
                  :href="
                    addCCToRoute(`/jobs?${QueryParameters.PRIMARY_LOCATION}=` + encodeURIComponent(`${hiring_city.name}, ${hiring_city.state_abbr}`))"
                >
                  {{ hiring_city.name }}
                </a>
              </p>
            </div>
          </div>
        </div>
      </vs-tab>
      <vs-tab label="Company Overview" title="Company Overview" v-if="job.company.content">
        <div class="tab-text tab-company-overview">
          <div class="flex job-detail-header-info">
            <div v-if="job.company.headquarters" class="job-detail-box">
              <p class="font-bold info-title">HEADQUARTERS</p>
              <p class="info-content">{{ job.company.headquarters }}</p>
            </div>
            <div v-if="job.company.employees" class="job-detail-box">
              <p class="font-bold info-title">EMPLOYEES</p>
              <p class="info-content">{{ job.company.employees }}</p>
            </div>
            <div class="job-detail-box">
              <p class="font-bold info-title">INDUSTRY</p>
              <p class="info-content">{{ job.company.industry }}</p>
            </div>
          </div>
          <div class="company-content text-editor-content company-content-imgs" v-html="job.company.content">
          </div>

          <div class="company-video-container" v-if="job.company.video_url">
            <iframe
              :title="job.company.name"
              width="100%"
              :src="job.company.video_url"
              frameborder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </div>

          <div class="company-image-container" v-if="job.company.images && job.company.images.length > 0">
            <h2 class="company-image-title">
              Inside {{ job.company.name }}
            </h2>

            <gallery :job="job"></gallery>
          </div>
        </div>
      </vs-tab>
    </vs-tabs>
    <div v-view="toggleApplyNowCallout" class="h-px"></div>
    <div
      ref="calloutContainer"
      class="apply-button-container flex justify-between items-center"
      :class="{ 'sticky-button-container': showApplyCallout, 'hidden': jobDetailsTabSelected !== 0 }"
    >
      <p class="hidden lg:block container-text">Click “Apply Now” to get started.</p>
      <a
        @click="recordClick(job.id, job.slug, job.is_linkout ? 1 : 0, job.linkout_url, job.location.name.toLowerCase().replace(/ /g, '-').replace(/[^\w-]+/g, ''))"
        class="w-full lg:w-auto"
      >
        <primary-button class="hidden w-full lg:w-auto lg:block" title="Apply Now">Apply Now</primary-button>
        <primary-button size="large" class="handle-btn w-full lg:hidden" title="Apply Now">Apply Now</primary-button>
      </a>
    </div>
    <!--we need to fill the height space, when the element is "fixed"-->
    <!--in this case we fully know when when the right side scrolling is done-->
    <div class="hidden lg:block w-full h-64px" v-show="showApplyCallout"></div>
  </div>
  <div style="min-height:500px" v-else>
  </div>
</template>

<script type="text/javascript">
import axios from 'axios';
import Events from '../../mixins/events'
import RearrangeCategoriesMixin from '../../mixins/RearrangeCategoriesMixin'
import { slugify } from '../../utilities/slugify';
import CCRequestInputMixin from "../../mixins/CCRequestInputMixin";
import QueryParameters from "../../utilities/queryparameters";

    export default{
        props: {
            id : {
                type : Number,
                required: true
            },
            jobSlug : {
                type : String
            },
            locationSlug : {
                type : String
            },
            locationId : {
                type : String
            },
            singleOnly: {
              type: Boolean,
              default: false
            },
            trackingCode : {
                type: String,
                default: ''
            }
        },

        mixins : [
            Events,
            CCRequestInputMixin,
            RearrangeCategoriesMixin
        ],

        data() {
            return {
                QueryParameters : QueryParameters,
                showApplyCallout: false,
                buttonVisible: true,
                calloutOffsetY: 0,
                spanRefTabs: null,
                selectedTabIndex: 0,
                job : null,
                jobDetailsTabSelected: 0
            }
        },

        created(){
            if (this.singleOnly) return;
            this.getJob();
        },

        updated() {
            this.rearrangeCategories();
        },

        methods: {

            inputTab(tabSelected) {
                this.jobDetailsTabSelected = tabSelected || 0;
            },

            getJob(){
                this.scrollToTop();
                this.$vs.loading({
                    container: "#job-details-"+this.locationId
                });
                let jobUrl = `/jobs/${ this.id }/${this.jobSlug}`;
                
                if( this.locationSlug ){
                    jobUrl = jobUrl + '/'+ this.locationSlug;
                }

                if( this.trackingCode ){
                    jobUrl = jobUrl + '?cc='+ this.trackingCode;
                }
                axios.get( jobUrl ).then( response => {
                    this.job = response.data.job;
                    this.$vs.loading.close( "#job-details-"+this.locationId+" > .con-vs-loading");
                }).catch(error => {
                });
            },

            /**
             * @param {number} tabSelected
             */
            resetOffset(tabSelected) {
                this.jobDetailsTabSelected = tabSelected || 0;
                this.scrollToTop();
                this.calloutOffsetY = 0;
            },

            slugify(str) {
                return slugify(str);
            },

            scrollToTop() {
                document.body.scrollTop = 0; // For Safari
                document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
            },

            /**
             * @return {number}
             */
            getBrowserHeight() {
                return (window.innerHeight || document.documentElement.clientHeight);
            },

            toggleApplyNowCallout(e) {
                if (e.target.element.type === 'button') {
                    if (e.target.rect.top >= (e.target.rect.height)) {
                        this.showApplyCallout = false;
                        this.buttonVisible = true;
                    } else {
                        let contentApplyNowBottomRef = null;
                        if (Viewport.isMobile || Viewport.isTablet) {
                            contentApplyNowBottomRef = this.$refs.contentApplyNowBottom;
                        }else {
                            contentApplyNowBottomRef = this.$refs.calloutContainer;
                        }

                        if (contentApplyNowBottomRef && this.showApplyCallout === false && contentApplyNowBottomRef.getBoundingClientRect().top > this.getBrowserHeight()) {
                            this.showApplyCallout = true;
                            this.buttonVisible = false;
                        }
                    }
                } else {
                    if (e.percentInView === 1 && this.showApplyCallout) {
                        if (this.calloutOffsetY === 0) {
                            this.calloutOffsetY = window.scrollY + 64; //64 here is the margin between the end of the content and the callout container
                        }
                    }

                    if (this.calloutOffsetY <= window.scrollY) {
                        if (this.showApplyCallout) {
                            this.showApplyCallout = false;
                        }

                    } else {
                        if (!this.showApplyCallout && !this.buttonVisible) {
                            this.showApplyCallout = true;
                        }
                    }
                }

                if (Viewport.isDesktopOrGreater) {
                    this.$refs.calloutContainer.style.width =
                        this.$refs.tabsContent.$el.clientWidth + "px";
                } else {
                    this.$refs.calloutContainer.style.left = 0;
                    this.$refs.calloutContainer.style.width = "100%";
                }
            },
            recordClick(job_id, job_slug, is_linkout, linkout_url, location_slug) {
                const url_apply = this.addCCToRoute(`/jobs/${job_id}/${job_slug}/${location_slug}`);
                const url_apply_out = this.addCCToRoute(`/jobs/${job_id}/${job_slug}/${location_slug}/apply_link_out`);
                this.trackJobApplyButtonClick(job_id, job_slug, is_linkout ? linkout_url : url_apply, url_apply_out, is_linkout ? '_blank' : '_self' );
            }
        },

        mounted() {
            this.$root.$on('jobSelected', () => {
                if (this.$root.activeJob === this.locationId) {
                    this.resetOffset();

                    if (this.$refs.tabsContent && this.spanRefTabs === null) {
                        this.spanRefTabs = this.$refs.tabsContent.$el.querySelector('span.line-vs-tabs');
                    }

                    if (this.spanRefTabs) {
                        this.spanRefTabs.style.left = '0px';
                        this.spanRefTabs.style.width = '109px';
                        this.spanRefTabs.style.height = '2px';
                        this.spanRefTabs.style.transform = 'scaleX(1)';
                        this.spanRefTabs.style.top = '38px';
                    }
                    this.selectedTabIndex = 0;
                }
            });

            setTimeout(() => {
                this.$forceUpdate();
            }, 100);
        },
    }
</script>

<style>
  .vs-tabs-primary .con-ul-tabs .line-vs-tabs {
    top: 38px !important;
  }
</style>
